export class AuthPopupRedirectUrl {
  isPopup(globalObject: Window): boolean {
    return globalObject.opener !== null && globalObject.opener !== globalObject
  }

  hasCode(link: string): boolean {
    const url = new URL(link)

    return url.searchParams.has('code') || url.hash.startsWith('#code=')
  }
}
